import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

interface FieldsetProps {
  title?: ReactNode;
  color?: string;
  textColor?: string;
  titleSize?: string;
  borderWidth?: number;
  borderRadius?: number;
  children: ReactNode;
  sx?: SxProps<Theme>;
}
const Fieldset = ({
  title,
  textColor = 'color.primary',
  color = 'grey.800',
  titleSize = '1rem',
  borderWidth = 1,
  borderRadius = 2,
  children,
  sx = {},
  ...props
}: FieldsetProps) => {
  return (
    <Box
      component="fieldset"
      sx={{
        borderColor: color,
        borderWidth: borderWidth,
        borderRadius: borderRadius,
        ...sx,
      }}
      {...props}
    >
      {title && (
        <Typography
          component="legend"
          sx={{
            color: textColor,
            fontSize: titleSize,
          }}
        >
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
};
export default Fieldset;
